import axios from "../../utils/axios";

async function update(data) {
    console.log("data", data);
  return await axios.patch("single/taxes", data);
}

const taxService = {
  update,
};
export default taxService;